import * as tslib_1 from "tslib";
import { HttpClient, HttpRequest, } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var MLSkillsService = /** @class */ (function (_super) {
    tslib_1.__extends(MLSkillsService, _super);
    function MLSkillsService(http) {
        var _this = _super.call(this, http, MapperService.mlSkillMap) || this;
        _this._endpoint = '/odata/MLSkills';
        return _this;
    }
    MLSkillsService.prototype.createMLSkill = function (data, mlpackageVersionId) {
        var MLSkillCreationRequest = {
            Description: data.description,
            MlPackageId: data.modelId,
            MlPackageVersionId: mlpackageVersionId,
            Name: data.name,
            Processor: data.processor,
        };
        var payload = { MLSkillCreationRequest: MLSkillCreationRequest };
        var req = new HttpRequest('POST', this._endpoint + "/UiPath.Server.Configuration.OData.CreateMLSkill", JSON.stringify(payload));
        return this._http.request(req);
    };
    MLSkillsService.prototype.rollbackMLSkillToPreviousVersion = function (mlskillId) {
        return this._http.post(this._endpoint + "('" + mlskillId + "')/UiPath.Server.Configuration.OData.RollbackToPreviousVersion", null);
    };
    return MLSkillsService;
}(ODataService));
export { MLSkillsService };
